import { render, staticRenderFns } from "./finance-package-list.vue?vue&type=template&id=f3dda51e&scoped=true&"
import script from "./finance-package-list.vue?vue&type=script&lang=js&"
export * from "./finance-package-list.vue?vue&type=script&lang=js&"
import style0 from "./finance-package-list.vue?vue&type=style&index=0&id=f3dda51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dda51e",
  null
  
)

export default component.exports